import { css } from "@linaria/core";
import { easings } from "../css-tokens/easings";
import { colors } from "../design-tokens/colors";

export const wrapper = css`
  position: relative;

  height: 35px;
  width: 35px;

  box-shadow: 0 0 10px rgba(0, 0, 0, 0.16);
  background: #fff;
  border-radius: 50%;

  display: flex;
  justify-content: center;
  align-items: center;

  color: rgb(117 119 131);

  transition: background 0.1s linear, color 0.1s linear,
    transform 0.1s ${easings.inOutCubic};

  padding-left: 2px;

  &.inversed {
    padding-right: 2px;
    padding-left: 0;
  }

  &[disabled] {
    background: #fff;
    color: rgb(206 206 209);
  }

  &:not([disabled]):hover {
    background: ${colors.accent()};
    color: #fff;
  }

  &:not([disabled]):active {
    transform: scale(0.95);
  }
`;
